module.exports = __webpack_public_path__ + "static/media/quote-ford-mindset-fr.e6f16846.png";